module.exports = __webpack_public_path__ + "static/media/icon_thankyou-email.52221123.svg";